









































































































import { cloneDeep } from 'lodash-es';
import Vue from 'vue';
import {
  defineComponent,
  ref,
  computed,
  toRefs,
  PropType,
  onMounted,
  getCurrentInstance,
  ComponentInternalInstance,
} from '@vue/composition-api';
import { useCreativeIs, useStdCreativeAdgroupIs } from '@tt4b/ttam-hooks';
import TtamInfiniteScrollContainer from 'src/components/common/infinite-scroll-container/index.vue';
import {
  MaterialType,
  FullNormalFormData,
  MaterialLibrarySortOptions,
  NativeMaterialLibrarySortOptions,
  NativeMaterialLibraryFilterOptions,
  AcoFormData,
  CampaignFormData,
  AdgroupFormData,
  NormalCreative,
} from '@tt4b/ttam-enums';
import TtamMaterialLibrary from './index';

const name = 'ttam-material-library-videos-only-compose';

export default defineComponent({
  name,

  components: {
    TtamInfiniteScrollContainer,
    TtamLibraryHeader: TtamMaterialLibrary.TtamLibrayHeaderLite,
    TtamLibraryListTips: TtamMaterialLibrary.TtamLibraryTips,
    TtamLibraryListItem: TtamMaterialLibrary.TtamLibraryListItem,
    TtamLibraryListEmpty: TtamMaterialLibrary.TtamLibraryListEmptyLite,
  },

  model: { prop: 'selectedIds', event: 'change' },

  // todo spf 简化入参
  props: {
    isHideLink: {
      type: Boolean,
      default: false,
    },
    onFilesSelected: {
      type: Function,
    },
    componentToRender: {
      type: Object,
    },
    isOpen: { type: Boolean, default: false },
    isLoading: { type: Boolean, default: false },
    isMaskVisible: { type: Boolean, default: false },
    canCloseOnClickMask: { type: Boolean, default: false },
    list: { type: Array, default: () => [] },
    type: { type: String as PropType<MaterialType>, default: MaterialType.Video },
    param: {
      type: Object as PropType<{
        keyword: '';
        sortType: number | boolean;
        filterTypes: number[];
        page: number;
        totalPage: number;
      }>,
      default: () => ({}),
    },
    limit: { type: Number, default: 20 },
    topHeight: { type: Number },
    selectedIds: { type: Array as PropType<number[]>, default: () => [] },

    createMode: { type: String, default: () => '' },
    campaignData: { type: Object as PropType<CampaignFormData>, default: () => ({}) },
    adgroupData: { type: Object as PropType<AdgroupFormData>, default: () => ({}) },
    creativeData: {
      type: Object as PropType<FullNormalFormData & AcoFormData>,
      default: () => ({} as FullNormalFormData),
    },
    normalCreativeData: {
      type: Object as PropType<NormalCreative>,
      default: () => ({}),
    },
  },

  setup(props, { emit }) {
    const { proxy: _this } = getCurrentInstance() as ComponentInternalInstance;
    const slipDirection = ref(document.dir === 'rtl' ? 'slide-left' : 'slide-right');
    const {
      type,
      isLoading,
      selectedIds,
      campaignData,
      createMode,
      adgroupData,
      creativeData,
      normalCreativeData,
      param,
    } = toRefs(props);
    const uploadFormat = `${_this.$t('module_ad_upload_format')}`;
    const sortType = computed(() => param.value.sortType);
    const isNativeType = computed(() => type.value === MaterialType.Native);
    const isPlayableType = computed(() => type.value === MaterialType.Playable);
    const { isAco } = useStdCreativeAdgroupIs({
      adgroupFormData: adgroupData,
      campaignFormData: campaignData,
    });
    const { isNative, isAcoWithTtaNativeAds } = useCreativeIs({
      campaignFormData: campaignData,
      adgroupFormData: adgroupData,
      normalCreativeData,
      createMode,
    });
    const isNativePullPost = computed(() => isNative.value && isNativeType.value);
    const _topHeight = computed(() => props.topHeight ?? Vue.prototype.$TTAMUI?.headerHeight);

    /** filter */
    const filterOptions = NativeMaterialLibraryFilterOptions();
    const keyword = computed(() => props.param.keyword ?? '');
    const defaultFilterType = [filterOptions[1]?.children[0]?.id || 1];
    const filterTypes = computed(() => props.param.filterTypes || defaultFilterType);

    /** sort */
    // const defaultSortType = isNativeType.value
    //   ? NativeMaterialLibrarySortOptions()[0].value
    //   : MaterialLibrarySortOptions()[0].value;
    const sortOptions = computed(() =>
      isNativeType.value ? NativeMaterialLibrarySortOptions() : MaterialLibrarySortOptions(),
    );

    /** page */
    const page = computed(() => props.param.page || 1);
    const totalPage = computed(() => props.param.totalPage || 1);

    function onParamChange(data = {}, tea) {
      if (tea) {
        emit('tea-report', tea);
      }
      emit('param-change', {
        keyword: keyword.value,
        sortType: sortType.value,
        filterTypes: filterTypes.value,
        page: page.value,
        totalPage: totalPage.value,
        ...data,
      });
    }

    const title = _this.$t('module_ad_upload_title_video_s');
    const { isShowIdentity } = TtamMaterialLibrary.usePropsIsShowIdentity({
      isNative,
      isAcoWithTtaNativeAds,
    });
    const { isShowCommonFIlter } = TtamMaterialLibrary.usePropsIsShowCommonFilter({ type });
    const { isShowTtNativeFilter } = TtamMaterialLibrary.usePropsIsShowTtNativeFilter({
      type,
      isNative,
      creativeData,
    });
    const { acoImageIdList, acoVideoIdList } = TtamMaterialLibrary.usePropsAcoMaterialList({
      isAco,
      isNative,
      formData: creativeData,
    });

    const { avatar, name: identityName } = TtamMaterialLibrary.usePropsIdentityInfo({ creativeData });

    const identityData = computed(() => ({ avatar: avatar.value, name: identityName.value }));

    const isHideLinkAndSort = computed(() => [MaterialType.Playable].includes(type.value));

    function onClickItem(item) {
      emit('tea-report', 'smb_create_ad_video_lib_choose_video');
      const selectedCopy = cloneDeep(selectedIds.value);
      const idx = selectedCopy.indexOf(item.id);
      if (idx > -1) {
        selectedCopy.splice(idx, 1);
      } else {
        selectedCopy.push(item.id);
      }
      emit('change', selectedCopy);
    }

    function onAppend() {
      if (!props.list?.length || isLoading.value) {
        return;
      }
      emit('append');
    }

    function onSearch() {
      emit('search');
    }

    function onCancel() {
      emit('close');
    }

    function onConfirm() {
      emit('confirm', selectedIds.value);
    }
    onMounted(() => {
      emit('mounted');
    });
    return {
      isAco,
      isNativeType,
      isNativePullPost,
      isPlayableType,
      isShowIdentity,
      isHideLinkAndSort,
      isShowCommonFIlter,
      isShowTtNativeFilter,
      uploadFormat,
      isAcoWithTtaNativeAds,
      title,
      keyword,
      sortType,
      sortOptions,
      filterTypes,
      filterOptions,
      identityData,
      slipDirection,
      acoImageIdList,
      acoVideoIdList,
      _topHeight,
      onAppend,
      onSearch,
      onCancel,
      onConfirm,
      onClickItem,
      onParamChange,
    };
  },
});
